import { render, staticRenderFns } from "./ServicePage.vue?vue&type=template&id=8e57e0c2&scoped=true&"
import script from "./ServicePage.vue?vue&type=script&lang=js&"
export * from "./ServicePage.vue?vue&type=script&lang=js&"
import style0 from "./ServicePage.vue?vue&type=style&index=0&id=8e57e0c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e57e0c2",
  null
  
)

export default component.exports